import * as React from 'react';
import MuiStack, { StackProps } from '@mui/material/Stack';

const Stack = React.forwardRef((props: StackProps, ref) => {
  return <MuiStack ref={ref} {...props} />;
});

export default Stack;
